module.exports = __webpack_public_path__ + "static/media/Arrow-down-gray.fd4abb3e.svg";